import * as React from "react";
import * as ReactDOM from "react-dom";
import { createChangeEventDetails } from "../../internals/createBaseUIEventDetails.js";
import { isOutsideEvent, getTabbableAfterElement, getNextTabbable, getTabbableBeforeElement } from "../../floating-ui-react/utils/tabbable.js";
import { contains } from "../../../utils/shadowDom.js";
import { focusOut } from "../../internals/reason-parts.js";
function useTriggerFocusGuards(store, triggerElementRef) {
  const preFocusGuardRef = React.useRef(null);
  function handlePreFocusGuardFocus(event) {
    ReactDOM.flushSync(() => {
      store.setOpen(false, createChangeEventDetails(focusOut, event.nativeEvent, event.currentTarget));
    });
    const previousTabbable = getTabbableBeforeElement(preFocusGuardRef.current);
    previousTabbable?.focus();
  }
  function handleFocusTargetFocus(event) {
    const positionerElement = store.select("positionerElement");
    if (positionerElement && isOutsideEvent(event, positionerElement)) {
      store.context.beforeContentFocusGuardRef.current?.focus();
    } else {
      ReactDOM.flushSync(() => {
        store.setOpen(false, createChangeEventDetails(focusOut, event.nativeEvent, event.currentTarget));
      });
      let nextTabbable = getTabbableAfterElement(store.context.triggerFocusTargetRef.current || triggerElementRef.current);
      while (nextTabbable !== null && contains(positionerElement, nextTabbable)) {
        const prevTabbable = nextTabbable;
        nextTabbable = getNextTabbable(nextTabbable);
        if (nextTabbable === prevTabbable) {
          break;
        }
      }
      nextTabbable?.focus();
    }
  }
  return {
    preFocusGuardRef,
    handlePreFocusGuardFocus,
    handleFocusTargetFocus
  };
}
export {
  useTriggerFocusGuards
};
//# sourceMappingURL=useTriggerFocusGuards.js.map
